import { render, staticRenderFns } from "./PorletCalendar.vue?vue&type=template&id=ad997f04"
import script from "./PorletCalendar.vue?vue&type=script&lang=js"
export * from "./PorletCalendar.vue?vue&type=script&lang=js"
import style0 from "./PorletCalendar.vue?vue&type=style&index=0&id=ad997f04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports